export const SCREENS = {
    APPOINTMENT_SCREEN: 'appointment-screen',
    CHANGE_CENTER: 'change-center',
    CHANGE_LOCATION: 'change-location',
    CONFIRM_PHONE: 'confirm-phone',
    CONFIRMED_APPOINTMENT: 'confirmed-appointment',
    NON_CMC_CITY: 'non-cmc-city',
    HOME_LOCATION: 'change-home-center',
    BOOK_APPOINTMENT: 'book-appointment',
    CHANGE_HOME_CENTER: 'change-home-center',
    SELECT_MAP_LOCATION: 'select-map-location'
};

export const TRACKING_EVENTS = {
    BOOK_APPOINTMENT_PAGE_OPEN: 'book_appointment_page_open',
    BOOK_APPOINTMENT_TAP_BACK: 'book_appointment_tap_back',
    BOOK_APPOINTMENT_TAP_CLOSE: 'book_appointment_tap_close',
    BOOK_APPOINTMENT_TAP_CONFIRM: 'book_appointment_tap_confirm',
    BOOK_APPOINTMENT_TAP_CHANGE_CENTER: 'book_appointment_tap_change_center',
    BOOK_APPOINTMENT_LOCATION_COMPLETE: 'booking_location_complete',
    BOOKING_LOCATION_SELECT: 'booking_location_select',
    BOOK_APPOINTMENT_CENTER_SELECTION_COMPLETE: 'book_appointment_center_selection_complete',
    BOOK_APPOINTMENT_SLOT_TAP_SELECT_DATE: 'book_appointment_slot_tap_select_date',
    BOOK_APPOINTMENT_SLOT_TAP_SELECT_TIME: 'book_appointment_slot_tap_select_time',
    BOOK_APPOINTMENT_CENTER_AUTO_SELECTED: 'book_appointment_center_auto_selected',
    BOOK_APPOINTMENT_TAP_GO_HOME: 'book_appointment_tap_go_home',
    BOOK_APPOINTMENT_TAP_POST_ON_OLX: 'book_appointment_tap_post_on_olx',
    BOOK_APPOINTMENT_SUCCESSFUL: 'book_appointment_successful',
    BOOK_APPOINTMENT_CITY_NOT_SERVICEABLE: 'book_appointment_city_not_serviceable',
    BOOK_APPOINTMENT_ERROR_SHOWN: 'book_appointment_error_shown',
    BOOK_APPOINTMENT_TAP_RETRY: 'book_appointment_tap_retry',
    BOOK_APPOINTMENT_TAP_CALL_CENTER: 'book_appointment_tap_call_center',
    BOOK_APPOINTMENT_TAP_CLOSE_DROPDOWN: 'book_appointment_tap_close_dropdown',
    BOOK_APPOINTMENT_TAP_CLOSE_CONFIRM: 'book_appointment_tap_close_confirm',
    BOOK_APPOINTMENT_TAP_CLOSE_CANCEL: 'book_appointment_tap_close_cancel',
    BOOK_APPOINTMENT_TAP_HOME_INSPECTION: 'book_appointment_tap_home_inspection',
    BOOK_APPOINTMENT_TAP_STORE_INSPECTION: 'book_appointment_tap_store_inspection',
    BOOK_APPOINTMENT_LOCATION_SELECT: 'book_appointment_location_select',
    BOOK_APPOINTMENT_LOCATION_COMPLETE_HOME: 'book_appointment_location_complete',
    BOOK_APPOINTMENT_TAB_GET_DIRECTIONS: 'book_appointment_tap_get_directions',
    BOOK_APPOINTMENT_CENTRES_SHOWN: 'book_appointment_centers_shown',
    BOOK_APPOINTMENT_TAB_TOGGLE: 'book_appointment_tab_toggle',
    BOOK_APPOINTMENT_SLOTS_SHOWN: 'book_appointment_slots_shown',
    BOOK_APPOINTMENT_TAP_UNABLE_TO_LOCATE_STORE: 'book_appointment_tap_unable_to_locate_store',
    BOOK_APPOINTMENT_TAP_NEXT: 'book_appointment_tap_next',
    BOOK_APPOINTMENT_USE_CURRENT_LOCATION: 'book_appointment_use_current_location',
    BOOKING_SLOT_SELECTION: 'booking_slot_selection',
    BOOKING_GPS_BLOCKED: 'booking_gps_blocked',
    BOOK_APPOINTMENT_TAP_STORE_SELECT: 'book_appointment_tap_store_select',
    DISCLAIMER_LINK_CLICKED: 'disclaimer_link_clicked',
    BOOK_APPOINTMENT_MANUAL_LOCATION: 'book_appointment_manual_location',
    GPS_BLOCKED: 'gps_blcoked',
    MANAGE_BOOKING_TAP_CTA: 'manage_booking_tap_cta',
    BOOK_APPOINTMENT_TAP_RESCHEDULE: 'book_appointment_tap_reschedule',
    BOOK_APPOINTMENT_TAP_CANCEL: 'book_appointment_tap_cancel',
    BOOK_APPOINTMENT_POPUP_SHOWN: 'book_appointment_popup_shown',
    BOOK_APPOINTMENT_POPUP_TAP_CTA: 'book_appointment_popup_tap_cta',
    MANAGE_DOCUMENTS_TAP_EXPAND: 'manage_documents_tap_expand',
    MANAGE_DOCUMENTS_TAP_CONTRACT: 'manage_documents_tap_contract',
    MANAGE_DOCUMENTS_TAP_CTA: 'manage_documents_tap_cta'
};

export const TRACKING_PAGES = {
    BOOKING_CENTER_LIST: 'booking_center_list',
    BOOKING_LOCATION: 'booking_location',
    BOOKING_CITY_NOT_SERVICEABLE: 'booking_city_not_serviceable',
    BOOKING_REVIEW_USER_DETAILS: 'booking_review_user_details',
    BOOKING_SLOT_SELECTION: 'booking_slot_selection',
    BOOKING_CONFIRMATION: 'booking_confirmation',
    BOOKING_CANCELLED: 'booking_cancelled',
    BOOKING_HOME_INS_ADD: 'booking_home_inspection_address',
    BOOKIN_HOME_ADD_SLOT_SEL: 'booking_home_inspection_slot_selection',
    BOOKING_MAP: 'booking_map',
    BOOKING_ADDRESS_WIDGET_SHOWN: 'booking_address_widget_shown',
    BOOKING_LOCATION_WIDGET_SHOWN: 'booking_location_widget_shown',
    BOOKING_HOME_INSPECTION: 'booking_home_inspection',
    BOOKING_STORE_INSPECTION: 'booking_store_inspection',
    LOCATION_NOT_SERVICEABLE: 'location_not_serviceable',
    MANAGE_DOCUMENTS_WIDGET_SHOWN: 'manage_documents_widget_shown',
    MANAGE_BOOKING_WIDGET_SHOWN: 'manage_booking_widget_shown',
    LOGIN_POPUP_SHOWN: 'login_popup_shown'
};

export const FLOW_TYPES = {
    NO_DRAFT: 'instant_sell_new_booking_no_draft',
    RESCHEDULE: 'instant_sell_reschedule_booking',
    INSPECTION_HOME: 'INSPECTIONHOME',
    INSPECTION_ONLY: 'INSPECTION'
};

export const STORAGE_KEYS = {
    APPOINTMENT_DETAILS: 'appointment-details'
};

export const APPOINTMENT_FLOW_TYPES = {
    O2O_POSTING: 'o2o_posting',
    O2O_HOMEPAGE_WIDGET: 'o2o_homepage_widget',
    O2O_LISTING: 'o2o_listing_load',
    PAID_DIRECT: 'paid_direct',
    ORGANIC_DIRECT: 'organic_direct'
};

export const APPOINTMENT_FLOW_TYPES_RAW = {
    POSTING: 'posting',
    LISTING: 'listing'
};

export const APPOINTMENT_ERROR = {
    UN_AUTHORIZED: 1201,
    BOOKING_EXIST: 409,
    SLOT_TAKEN: 1501
};

export const BOOKING_STATES = {
    CANCELLED: 'CANCELLED',
    CONFIRMED: 'CONFIRMED'
};

export const DATA_AUT_IDS = {
    AP_CONFIRMED_TITLE: 'ap_confirmed_title',
    AP_CONFIRMED_SUB_TITLE: 'ap_confirmed_sub_title',
    AP_CANCELLED_TITLE: 'ap_cancelled_title',
    BOOK_STORE_INS_TITLE: 'book_store_ins_title',
    BOOK_STORE_INS_SUB_TITLE: 'book_store_ins_sub_title',
    BOOK_HOME_INS_TITLE: 'book_home_ins_title',
    BOOK_HOME_INS_SUB_TITLE: 'book_home_ins_sub_title',
    CHOOSE_CENTRE_TITLE: 'choose_store_title',
    AP_HEADER: 'appointment_header',
    CHANGE_LOCATION_TITLE: 'change_location_title',
    CHANGE_LOCATION_TEXT: 'change_location_text',
    SEL_LOCATION: 'selected_location',
    SEL_LOCATION_TXT: 'selected_location_txt',
    DATES_CONT: 'date_slot_container',
    TIMES_CONT: 'times_slot_container',
    LOCATION_CHANGE_CONT: 'location_change_cont',
    CONFIRM_AP_CTA: 'confirm_ap_cta',
    BACK_ICON_AP: 'back_icon_ap',
    CROSS_ICON_AP: 'cross_icon_ap',
    NEAREST_CENTRE_TEXT: 'nearest_centre_text',
    SEL_CENTRE_NAME: 'sel_centre_name',
    SEL_CENTRE_ADD: 'sel_centre_add',
    SEL_CENTRE_KM: 'sel_centre_km',
    CAR_TITLE: 'car_title',
    CAR_VARIANT: 'car_variant',
    CAR_MILEAGE: 'car_mileage',
    AP_TIME: 'ap_time',
    AP_DATE: 'ap_date',
    AP_DAYS_LEFT: 'ap_days_left',
    USER_MOB_NUM: 'user_mob_num',
    CENTRE_WITH_ID: 'centre_',
    SELECT_LOC_BTN: 'select_loc_btn',
    STORE_NAME_TXT: 'store_name_txt',
    STORE_ADDRESS: 'store_address',
    STORE_PHONE_NUM: 'store_phone_num',
    SEL_LOC_MAP: 'sel_loc_map',
    REQ_DOC_LIST: 'req_doc_list',
    CAROUSAL_ITEM: 'carousal_item',
    MARK_AS_SOLD_BTN: 'markAsSoldButton',
    EDIT_AD_BTN: 'editAdButton',
    LEARN_MORE_BTN: 'learnMoreButton',
    REPUBLISH_BTN: 'republishButton',
    MONETIZABLE_BTN: 'monetizableButton',
    FEATURE_AD_BTN: 'featureAdButton'
};

export const NAME_TO_LOCATION_ID = [
    {
        code: 'DNCR',
        id: '4058659'
    },
    {
        code: 'MUM',
        id: '4058997'
    },
    {
        code: 'KOL',
        id: '4157275'
    },
    {
        code: 'BLR',
        id: '4058803'
    },
    {
        code: 'CHE',
        id: '4059162'
    },
    {
        code: 'HYD',
        id: '4058526'
    },
    {
        code: 'PUN',
        id: '4059014'
    },
    {
        code: 'JPR',
        id: '4059123'
    },
    {
        code: 'MYS',
        id: '4058841'
    },
    {
        code: 'IDR',
        id: '4058916'
    },
    {
        code: 'COM',
        id: '4059164'
    },
    {
        code: 'NSH',
        id: '4059002'
    },
    {
        code: 'AHM',
        id: '4058677'
    }
];

export const TABS = {
    HOME_TAB: 'home',
    STORE_TAB: 'store'
};

export const ICON_URLS = {
    STORE_INSPECTION_LOGO: '/external/base/img/store-inspection-logo.svg',
    STORE_INSPECTION_LOGO_REVAMP: '/external/base/img/store-inspection-logo-new.svg',
    HOME_INSPECTION_LOGO: '/external/base/img/home-inspection-logo.svg',
    STORE_INSPECTION_LOGO_TR: '/external/base/img/otoplus/home-to-store.svg',
    HOME_INSPECTION_LOGO_TR: '/external/base/img/otoplus/store-to-home.svg',
    HOME_INSPECTION_TR: '/external/base/img/otoplus/locationHome.svg'
};

export const GPS_STATUS = {
    REJECTED: 'rejected',
    GRANTED: 'granted'
};

export const ADDRESS_TYPE = {
    NEIGHBOURHOOD: 'NEIGHBOURHOOD',
    CITY: 'CITY',
    STATE: 'STATE',
    COUNTRY: 'COUNTRY'
};

export const LANDMARK_IDENTIFIER = '#landmark#';

export const INSPECTION_TYPES = {
    STORE: 0,
    HOME: 1
};

export const TRACKING_EVENTS_FIELD_NAMES = {
    LOCATION: 'location',
    ADDRESS: 'address'
};
